import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ContextApi } from "../../../store/ContextApi";
import PageTitle from "../../layouts/PageTitle";
import SpinnerLoading from "../../components/spinner-loading/SpinnerLoading";
import FaildLoadData from "../../global-components/FaildLoadData/FaildLoadData";
import { Link } from "react-router-dom";
import LoadingScreen from "../../components/loading-screen/LoadingScreen";
import { getNewsLettersFunc } from "../../../store/custom-actions/news-letters-actions/GetNewsLettersSlicer";
import NewEmailForm from "../../custom-forms/news-letters/NewEmailForm";
import NewMessage from "../../custom-forms/news-letters/NewMessage";
import swal from "sweetalert";
import { deleteEmailFunc } from "../../../store/custom-actions/news-letters-actions/DeleteEmailSlicer";
import { toast } from "react-toastify";
import { verifyEmailFunc } from "../../../store/custom-actions/news-letters-actions/VerifyEmailSlicer";
import EmptyData from "../../components/empty-data/EmptyData";
import checkPermissions from "../../global-functions/checkPermissionsFunc";
import { useTranslation } from "react-i18next";

export default function NewsLettersPage() {
    const {t} = useTranslation();
    const {loading:getEmailsLoading , data:emailsData} = useSelector(state => state.getNewsLettersSlicer)
    const {loading:verifyEmailLoading} = useSelector(state => state.verifyEmailSlicer)
    const {loading:deleteEmailLoading} = useSelector(state => state.deleteEmailSlicer)
    const contextApi = useContext(ContextApi);
    const news_API_URL = `${process.env.REACT_APP_VERSEL_API}/api/dashboard/newsletters`;
    const [searchValue , setSearchValue] = useState("");
    const dispatch = useDispatch();
    const [emailsList , setEmailsList] = useState([])
    const [showNewEmailForm , setShowNewEmailForm] = useState()
    const [showNewMessageForm , setShowNewMessageForm] = useState()

    useEffect(() => {
        const getPersons = async () => {
          try {
            dispatch(getNewsLettersFunc(news_API_URL))
          } catch (error) {
            console.log(error);
          }
        };
        getPersons();
      }, []);
      useEffect(() => {
        emailsData && setEmailsList(emailsData);
        emailsData && (jobData.current = emailsData.slice(
            activePag.current * sort,
            (activePag.current + 1) * sort
          ));
      }, [emailsData]);
      const sort = 20;
      let paggination = Array(Math.ceil(emailsList.length / sort))
        .fill()
        .map((_, i) => i + 1);
    
      const activePag = useRef(0);
      const jobData = useRef(
        emailsList.slice(
          activePag.current * sort,
          (activePag.current + 1) * sort
        )
      );
      const onClick = (i) => {
        activePag.current = i;
        jobData.current = emailsList.slice(
          activePag.current * sort,
          (activePag.current + 1) * sort
        );
      };
      const search = () => {
        if(searchValue !== "") {
          const searchResult = emailsData &&
          emailsData.length >= 1 && emailsData.filter((state) =>  state.email.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase()));
          jobData.current = searchResult
        }else {
          dispatch(getNewsLettersFunc(news_API_URL))
        }
      }
      useEffect(() => {
        searchValue === "" && dispatch(getNewsLettersFunc(news_API_URL));
      },[searchValue])

      const verifyEmailFunction = async (id) => {
        const verifingFunction = () => {
          try {
            dispatch(verifyEmailFunc({api : `${news_API_URL}/verify-mail-send` , data : {newsletter_id : id}}))
            .then((result) => {
              if(result.payload.success === true){
                dispatch(getNewsLettersFunc(news_API_URL));
                toast.success(`${result.payload.message} !`, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
              })
              }
            })
          }
          catch(error) {
            swal({
              title: t("Error"),
              text: error,
              icon: "error",
              buttons: true,
            })
          }
        }
        swal({
          title: t("Confirm Verify This Email"),
          text: t(`Once Verifyed , You Can Send messages for him!`),
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            verifingFunction()
          }
        });
      };

      const deleteEmailFunction = async (id) => {
        swal({
          title: t("Confirm Email Deletion"),
          text: t(`Once deleted, This Email will not be avilable`),
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            dispatch(deleteEmailFunc(`${news_API_URL}/${id}`))
            .then((result) => {
              if(result.payload.success === true){
                dispatch(getNewsLettersFunc(news_API_URL));
                toast.success(`${result.payload.message} !`, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
              })
              }
            })
          }
        });
      };


    return (
       <>
  <PageTitle motherMenu={"Dashboard"} activeMenu={"News Letters"} />

  <div className="d-flex justify-content-end align-items-center mt-2">
    {!getEmailsLoading && emailsList.length < 1 && (
      <>
        {checkPermissions(
          "create newsletters",
          <Link
            className="btn btn-primary btn-sm"
            onClick={() => setShowNewEmailForm(true)}
          >
            {t("New Email")}
          </Link>
        )}
        {!getEmailsLoading &&
          emailsList.length >= 1 &&
          checkPermissions(
            "create notifications",
            <Link to="/post-news" className="btn btn-primary btn-sm ms-1">
              {t("New Message")}
            </Link>
          )}
      </>
    )}
  </div>

  {/* تحميل */}
  {getEmailsLoading ? (
    <SpinnerLoading />
  ) : emailsData ? (
    emailsList && emailsList.length >= 1 ? (
      <div className="col-12">
        <div className="card">
          {/* الهيدر */}
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">{t("Emails")}</h4>
            <div className="d-flex align-items-center">
              {/* البحث */}
              <div className="input-group me-2">
                <span
                  className="input-group-text"
                  onClick={() => search()}
                  style={{ cursor: "pointer" }}
                >
                  <i className="fa fa-search text-primary"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search here..."
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </div>
              {/* الأزرار */}
              {checkPermissions(
                "create newsletters",
                <Link
                  className="btn btn-primary btn-sm"
                  onClick={() => setShowNewEmailForm(true)}
                >
                  {t("New Email")}
                </Link>
              )}
              {checkPermissions(
                "create notifications",
                <Link to="/post-news" className="btn btn-primary btn-sm ms-1">
                  {t("New Message")}
                </Link>
              )}
            </div>
          </div>

          {/* البودي */}
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered align-middle">
                <thead className="table-light">
                  <tr>
                    <th>#{t("ID")}</th>
                    <th>{t("Email")}</th>
                    <th>{t("Creation")}</th>
                    <th>{t("Last update")}</th>
                    <th>{t("Email verifing")}</th>
                    {checkPermissions(
                      ["create notifications", "delete newsletters"],
                      <th>{t("Actions")}</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {emailsData &&
                    jobData.current.map((person, index) => {
                      const creationDate = new Date(person.created_at);
                      const updatedDate = new Date(person.updated_at);

                      return (
                        <tr key={index}>
                          <td>{person.id}</td>
                          <td>{person.email}</td>
                          <td>
                            {creationDate.getFullYear()} /{" "}
                            {creationDate.getMonth() + 1} /{" "}
                            {creationDate.getDate()}
                          </td>
                          <td>
                            {updatedDate.getFullYear()} /{" "}
                            {updatedDate.getMonth() + 1} /{" "}
                            {updatedDate.getDate()}
                          </td>
                          <td>
                            <span
                              className={`badge ${
                                person.is_verified === 1
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {person.is_verified === 1
                                ? t("Verified")
                                : t("Not verified")}
                            </span>
                          </td>
                          {checkPermissions(
                            ["create notifications", "delete newsletters"],
                            <td>
                              {checkPermissions(
                                "delete newsletters",
                                <Link
                                  to="#"
                                  className="btn btn-danger btn-sm text-white me-1"
                                  onClick={() => deleteEmailFunction(person.id)}
                                >
                                  <i className="fa fa-trash"></i>
                                </Link>
                              )}
                              {person.is_verified !== 1 &&
                                checkPermissions(
                                  "create notifications",
                                  <Link
                                    to="#"
                                    className="btn btn-success btn-sm text-white"
                                    onClick={() =>
                                      verifyEmailFunction(person.id)
                                    }
                                  >
                                    {t("Verify")}
                                  </Link>
                                )}
                            </td>
                          )}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            {/* pagination */}
            <div className="d-sm-flex justify-content-between align-items-center mt-3 mb-2">
              <div className="text-muted small">
                {t("Showing")} {activePag.current * sort + 1}{" "}
                {t("To")}{" "}
                {emailsList.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : emailsList.length}{" "}
                {t("Of")} {emailsList.length} {t("Entries")}
              </div>
              <div className="pagination mb-0">
                <Link
                  to="#"
                  className={`page-link ${
                    activePag.current === 0 ? "disabled" : ""
                  }`}
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  <i className="fa fa-angle-double-left"></i>
                </Link>
                {paggination.map((number, i) => (
                  <Link
                    key={i}
                    to="#"
                    className={`page-link ${
                      activePag.current === i ? "active" : ""
                    }`}
                    onClick={() => onClick(i)}
                  >
                    {number}
                  </Link>
                ))}
                <Link
                  to="#"
                  className="page-link"
                  onClick={() =>
                    activePag.current + 1 < paggination.length &&
                    onClick(activePag.current + 1)
                  }
                >
                  <i className="fa fa-angle-double-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <EmptyData />
    )
  ) : (
    <FaildLoadData
      refetchDataFunc={() => dispatch(getNewsLettersFunc(news_API_URL))}
    />
  )}

  {/* شاشات تحميل */}
  <LoadingScreen loading={deleteEmailLoading} />
  <LoadingScreen loading={verifyEmailLoading} />

  {/* فورم الإيميل الجديد */}
  <NewEmailForm
    showForm={showNewEmailForm}
    hideForm={() => setShowNewEmailForm(false)}
  />
</>

    )
}